<template>
  <v-row no-gutters>
    <v-col>
      <div id="approval-list" :class="{ 'page-fullscreen': pageStore.isFullScreen }">
        <v-card tile :class="$vuetify.breakpoint.mdAndDown ? null : 'rounded-t-xl'">
          <PageHeader />

          <v-data-table
            loader-height="2"
            :headers="tableColumns"
            :items="tableItems"
            :loading="tableLoading"
            :height="pageStore.tableHeight"
            :options.sync="tableOptions"
            :server-items-length="tableTotalRec"
            :disable-items-per-page="true"
            :mobile-breakpoint="100"
            :items-per-page="20"
            fixed-header
            hide-default-footer
          >
            <!-- Load More -->
            <template v-slot:body.append v-if="loadMoreLoading">
              <tr>
                <td :colspan="tableColumns.length">
                  <div class="text-center" v-intersect.quiet="loadMore">
                    <v-progress-circular
                      v-if="tableItems.length > 0"
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </div>
                </td>
              </tr>
            </template>

            <!-- Arama Alanı -->
            <template v-slot:body.prepend>
              <tr style="zoom: 0.8; position: sticky; z-index: 2; top: 40px; background: #363351">
                <!-- Ref No -->
                <td class="pa-0">
                  <v-text-field filled disabled class="rounded-0 elevation-0" hide-details />
                </td>

                <!-- Cari Bilgileri -->
                <td class="pa-0">
                  <v-autocomplete
                    v-if="userData.role === 'SUPER'"
                    placeholder="Ara"
                    class="rounded-0 elevation-0"
                    v-model="tableSearchCustomer"
                    :items="tableSearchCustomerItems"
                    :filter="tableSearchCustomerFilter"
                    :loading="tableSearchCustomerLoading"
                    item-text="name1"
                    item-value="customer"
                    :menu-props="{ bottom: true, offsetY: true }"
                    :prepend-inner-icon="icons.mdiMagnify"
                    persistent-placeholder
                    filled
                    clearable
                    hide-details
                    attach
                  >
                    <template v-slot:item="data">
                      <v-row align="center" dense>
                        <v-col cols="4">
                          <v-chip
                            color="secondary"
                            label
                            class="d-flex justify-center text-caption"
                          >
                            {{ data.item.customer }}
                          </v-chip></v-col
                        >
                        <v-col cols="8">
                          <div class="text-caption text-truncate" style="max-width: 500px">
                            {{ data.item.name1 }}
                          </div>
                        </v-col>
                      </v-row>
                    </template>
                  </v-autocomplete>
                  <v-text-field v-else filled disabled class="rounded-0 elevation-0" hide-details />
                </td>

                <!-- Boş -->
                <td class="pa-0" v-for="(item, i) in tableEmptySearch" :key="i">
                  <v-text-field filled disabled class="rounded-0 elevation-0" hide-details />
                </td>
              </tr>
            </template>

            <!-- Sipariş Numarası -->
            <template #[`item.id`]="{ item }">
              <v-chip
                label
                :color="item.refno === 'HATA' ? 'error' : 'grey'"
                class="d-flex justify-center text-caption"
              >
                <span
                  class="text-caption text-xl-subtitle-2"
                  style="letter-spacing: 0.5px; color: azure"
                  >{{ item.id }}</span
                >
              </v-chip>
            </template>

            <!-- Müşteri -->
            <template #[`item.customer_name`]="{ item }">
              <div class="text-truncate" style="max-width: 500px !important">
                <div class="text-caption text-lg-subtitle-2 white--text">
                  {{ customerName(item.customer_name, item.adsoyad) }}
                </div>
              </div>
            </template>

            <!-- Sevkiyat -->
            <template #[`item.delivery_appr_desc`]="{ item }">
              <v-tooltip :color="item.prod_appr_color" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn 
                    fab block
                    class="rounded"
                    x-small
                    outlined
                    :color="item.prod_appr_color"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon> {{ stateIcon(item.prod_appr_color) }} </v-icon>
                  </v-btn>
                </template>
                <span>{{ item.delivery_appr_desc }}</span>
              </v-tooltip>
            </template>

            <!-- Üretim -->
            <template #[`item.prod_appr_desc`]="{ item }">
              <v-tooltip :color="item.delivery_appr_color" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    fab block
                    class="rounded"
                    x-small
                    outlined
                    :color="item.delivery_appr_color"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon> {{ stateIcon(item.delivery_appr_color) }} </v-icon>
                  </v-btn>
                </template>
                <span>{{ item.delivery_appr_desc }}</span>
              </v-tooltip>
            </template>

            <!-- Durum -->
            <template #[`item.manager_appr_desc`]="{ item }">
              <v-tooltip :color="item.manager_appr_color" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    fab
                    block
                    class="rounded"
                    x-small
                    outlined
                    :color="item.manager_appr_color"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon> {{ stateIcon(item.manager_appr_color) }} </v-icon>
                  </v-btn>
                </template>
                <span>{{ item.manager_appr_desc }}</span>
              </v-tooltip>
            </template>

            <!-- Sipariş Tarihi -->
            <template #[`item.update_datetime`]="{ item }">
              <v-tooltip color="chip" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-chip color="" class="d-flex justify-center" label v-bind="attrs" v-on="on">
                    <div
                      class="text-truncate d-flex align-center"
                      style="
                        width: 130px !important;
                        text-align: center;
                        font-size: 11px !important;
                        letter-spacing: 0.5px;
                        color: azure;
                      "
                    >
                      <v-icon color="" small class="mr-2">
                        {{ icons.mdiCalendarClock }}
                      </v-icon>
                      <div class="mr-1">
                        {{ item.update_datetime | moment("DD.MM.YYYY ") }}
                      </div>

                      <span> - {{ item.update_datetime | moment("HH:mm") }}</span>
                    </div>
                  </v-chip>
                </template>
                <div>
                  {{ item.update_datetime | moment("DD MMMM dddd") }}
                </div>
              </v-tooltip>
            </template>

            <!-- Görüntüle -->
            <template #[`item.viewing`]="{ item }">
              <div class="d-flex">
                <v-btn
                  depressed
                  style="height: 32px !important"
                  color="chip"
                  class="mr-1 text-capitalize"
                  @click="viewOrderAction(item)"
                >
                  Görüntüle
                </v-btn>
              </div>
            </template>
            <!-- Onaylama -->
            <template #[`item.confirmation`]="{ item }">
              <div class="d-flex">
                <ViewBtn :item="item" />
              </div>
            </template>
          </v-data-table>
          <OrderView v-if="orderStore.viewDialogModel" @saleCancel="saleCancel" />
        </v-card>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import Vue from "vue";
import store from "@/store";

import { ref, onUnmounted, watch, onMounted } from "vue-demi";

// Pinia
import { useOrderStore } from "@/stores/order";
import { usePageStore } from "@/stores/pageHeader";

// Utils
import { postData, querySearch } from "@utils";
import { useDebounceFn } from "@vueuse/core";
import { useToast } from "vue-toastification/composition";

// Component
import PageHeader from "@/components/PageHeader/Index.vue";
import OrderView from "./View.vue";
import ViewBtn from "./ViewBtn.vue";

// Icons
import {
  mdiCalendarClock,
  mdiTimerSand,
  mdiCancel,
  mdiCheck,
  mdiCheckAll,
  mdiMinus,
  mdiMagnify,
  mdiDownload,
  mdiDelete,
} from "@mdi/js";

export default {
  components: {
    PageHeader,
    OrderView,
    ViewBtn,
  },

  setup() {
    // Kullanıcı verileri
    const orderStore = useOrderStore();
    const pageStore = usePageStore();

    const userData = JSON.parse(localStorage.getItem("userData"));
    const toast = useToast();

    const pageSettings = () => {
      pageStore.pageTitle = "Bekleyen Siparişler";
      pageStore.pageIcon = mdiTimerSand;
      pageStore.hasFullScreen = true;
      pageStore.hasDownload = true;
      pageStore.hasDateRangeAll = false;
      pageStore.hasDateRange = true;
      pageStore.hasActions = false;

      pageStore.downloadHeader = {
        Durum: "aktif",
        Profil: "profile_id",
        "Kullanıcı Adı": "username",
        "Ad Soyad": "username",
        "Son Giriş Zamanı": "son_giris",
      };
    };

    // Table
    const tableRef = ref(null);
    const tableLoading = ref(true);
    const tableItems = ref([]);
    const tableTotalRec = ref(0);
    const tableEmptySearch = ref(0);
    // Table Columns
    const tableColumns = ref([
      {
        text: "ID",
        value: "id",
        align: "left",
        width: "100",
        sortable: false,
      },

      {
        text: "Müşteri",
        value: "customer_name",
        align: "left min-width-400 pl-0 pr-3 px-lg-3",
        sortable: false,
      },
    ]);

    if (userData.role === "COMMAN") {
      tableEmptySearch.value = 6;
      tableColumns.value.unshift({
        text: "",
        align: "right",
        value: "confirmation",
        width: "80px",
        sortable: false,
      });
      tableColumns.value.push(
        {
          text: "Sevkiyat",
          value: "delivery_appr_desc",
          align: "center pl-0 pr-3 px-lg-3",
          width: "70px",
          sortable: false,
        },
        {
          text: "Üretim",
          value: "prod_appr_desc",
          align: "center pl-0 pr-3 px-lg-3",
          width: "70px",
          sortable: false,
        },
        {
          text: "Durum",
          value: "manager_appr_desc",
          align: "center pl-0 pr-3 px-lg-3",
          width: "70px",
          sortable: false,
        },
        {
          text: "Sipariş Tarihi",
          align: "right pl-0 pr-3 px-lg-3",
          value: "update_datetime",
          width: "130px",
          sortable: false,
        },
        {
          text: "",
          align: "right px-1",
          value: "viewing",
          width: "100px",
          sortable: false,
        }
      );
    } else {
      tableEmptySearch.value = 3;
      tableColumns.value.push(
        {
          text: "Durum",
          value: "manager_appr_desc",
          align: "left pl-0 pr-3 px-lg-3",
          width: "150px",
          sortable: false,
        },
        {
          text: "Sipariş Tarihi",
          align: "right pl-0 pr-3 px-lg-3",
          value: "update_datetime",
          width: "130px",
          sortable: false,
        },
        {
          text: "",
          align: "right px-1",
          value: "viewing",
          width: "100px",
          sortable: false,
        }
      );
    }

    // Table Load More
    const tablePage = ref(1);
    const loadMoreLoading = ref(false);
    const loadMore = (isIntersecting) => {
      if (isIntersecting) {
        tablePage.value++;
        tableOptions.value.page = tablePage.value;
        if (!tableLoading.value) {
          tableFetch();
        }
      }
    };

    // Tablo Arama
    const tableSearchMattype = ref("");
    const tableSearchOrderNo = ref("");
    const tableSearchCustomer = ref("");

    const tableOptions = ref({
      sortBy: ["id"],
      sortDesc: [true],
    });

    // Cari bilgi arama
    const tableSearchCustomerFilter = (item, queryText, itemText) =>
      item.customer.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1 ||
      item.name1.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1;

    const tableSearchCustomerItems = ref([]);
    const tableSearchCustomerLoading = ref(false);

    const customerFetch = () => {
      tableSearchCustomerLoading.value = true;

      const data = {
        method: "getCustomersBySalDept",
        type: "select",
      };
      store
        .dispatch("postMethod", data)
        .then((response) => {
          tableSearchCustomerItems.value = response.detail;
        })
        .catch((e) => {
          Vue.swal({
            title: "Hata",
            text: e.message,
            width: "350px",
            icon: "error",
            background: "#FF4C51",
            showCloseButton: false,
            showConfirmButton: true,
            confirmButtonColor: "#cc3d41",
          });
        })
        .finally(() => {
          tableSearchCustomerLoading.value = false;
        });
    };

    const debouncedTableSearch = useDebounceFn(() => {
      tableFetch();
    }, 700);

    watch([tableSearchMattype, tableSearchOrderNo, tableSearchCustomer], () => {
      loadMoreLoading.value = false;
      tableLoading.value = true;
      tablePage.value = 1;
      tableOptions.value.page = 1;
      tableItems.value = [];

      debouncedTableSearch();
    });

    // API İstek
    const tableFetch = () => {
      tableLoading.value = true;

      postData(
        querySearch(
          {
            options: tableOptions.value,
            mattype: tableSearchMattype.value,
            erporderno: tableSearchOrderNo.value,
            cari_kod: tableSearchCustomer.value,
          },
          "subcustOrderListWaiting"
        )
      )
        .then((response) => {
          // API dönüşündeki hatalara bakıyoruz
          if (response.error) {
            throw new Error(response.msg);
          }

          // Toplam kayıt sayısı işleniyor
          tableTotalRec.value = Number(response.response.pagination.totalRec);

          // API'dan gelen veriler işleniyor

          // Responseda bir değer yoksa
          if (response.response.result.length === 0) {
            loadMoreLoading.value = false;
            return;
          }

          // Responsedan gelen veriler işleniyor
          response.response.result.map((item) => {
            tableItems.value.push({
              ...item,
            });
          });
          loadMoreLoading.value = false;
          if (tableTotalRec.value >= 20) {
            setTimeout(() => {
              loadMoreLoading.value = true;
            }, 300);
          }
          // Responstan gelen verilere göre loadmore değerlendiriliyor
        })
        .catch((e) => {
          // API hataya girdi
          toast.error(e.message, {
            position: "bottom-center",
          });
        })
        .finally(() => {
          // API işlemi bittikten sonra
          tableLoading.value = false;
        });
    };

    const deleteItem = (id) => {
      Vue.swal({
        title: "Emin misin?",
        text: "Silme işlemini onaylayın",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Onaylıyorum",
      }).then((result) => {
        if (result.isConfirmed) {
          postData({
            method: "deleteSale",
            id,
          }).then((response) => {
            tableFetch();
          });
        }
      });
    };

    const saleCancel = async ({ id }) => {
      orderStore.viewDialogModel = false;
      const { value: textarea } = await Vue.swal.fire({
        title: "Emin misin?",
        showCancelButton: true,
        confirmButtonText: "Onaylıyorum",
        input: "textarea",
        inputPlaceholder: "İptal nedeninizi kısaca açıklayınız.",
        inputValidator: (value) => {
          if (!value) {
            return "İptal nedeninizi yazınız";
          }
        },
      });

      if (textarea) {
        postData({
          method: "changeSubcustMngrStatus",
          id,
          status: 2,
          notes: textarea,
        }).then((response) => {
          if (response.error === 0) {
            loadMoreLoading.value = false;
            tableLoading.value = true;
            tablePage.value = 1;
            tableOptions.value.page = 1;
            tableItems.value = [];

            tableFetch();
            toast.success(response.msg, {
              position: "bottom-center",
            });
          } else {
            toast.error(response.msg, {
              position: "bottom-center",
            });
          }
        });
      }
    };

    const downloadTable = async () => {
      postData({
        method: "getOrderAndLinesToExcel",
      }).then((response) => {
        if (response.error === 0) {
          window.open(response.file, "_blank");
        }
      });
    };

    const viewOrderAction = (data) => {
      orderStore.viewDialogData = data;
      orderStore.viewDialogModel = true;
    };

    const customerName = (name, user) => {
      let result;
      result = name.split(" / ");
      if (result.length > 1) {
        result = result[0] + " | " + user.toUpperCase();
      } else {
        result = result[0];
      }
      return result;
    };

    const stateIcon = (state) => {
      let result;
      if (state === "warning") {
        result = mdiTimerSand;
      } else if (state === "error") {
        result = mdiCancel;
      } else if (state === "success") {
        result = mdiCheck;
      } else {
        result = mdiMinus;
      }
      return result;
    };

    onMounted(() => {
      pageSettings();
      if (userData.role === "SUPER") {
        customerFetch();
      }
      tableFetch();
    });

    onUnmounted(() => {
      pageStore.pageSettingsClear();
    });
    return {
      // Utils
      userData,
      orderStore,
      customerName,
      pageStore,
      customerFetch,
      stateIcon,

      // Table
      tableFetch,
      tableRef,
      tableColumns,
      tableItems,
      tableLoading,
      loadMore,
      loadMoreLoading,
      tableTotalRec,
      tableEmptySearch,
      tableOptions,

      // Table Search
      tableSearchMattype,
      tableSearchOrderNo,
      tableSearchCustomer,
      tableSearchCustomerFilter,
      tableSearchCustomerItems,
      tableSearchCustomerLoading,

      // API
      deleteItem,
      saleCancel,

      // Actions
      downloadTable,
      viewOrderAction,

      // Icons
      icons: {
        mdiTimerSand,
        mdiCancel,
        mdiCheckAll,
        mdiCheck,
        mdiMinus,
        mdiMagnify,
        mdiDownload,
        mdiDelete,
        mdiCalendarClock,
      },
    };
  },
};
</script>
